import wx from 'weixin-js-sdk'
import axios from './http';
import {signature} from './common.js'

const jsApiList = ['checkJsApi','updateAppMessageShareData','updateTimelineShareData']

function getJSSDK(url,dataForWeiXin) {
    var params = {
        url: url,
        official_account_code:'KXB'
    }
    params = signature(params);
    axios.get('https://as.wechat.jiankanghao.net/api/v1/getJsApi',{params}).then(res => {
        wx.config({
            debug: false,
            appId: res.data.data.appId,
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature, // 必填，签名
            jsApiList: jsApiList
        })
        wx.ready(function() {
            //分享给朋友、分享到QQ
            wx.updateAppMessageShareData({
                title: dataForWeiXin.title,
                desc: dataForWeiXin.desc,
                link: dataForWeiXin.link,
                imgUrl: dataForWeiXin.imgUrl,
                success:function(){

                }
            })
            //分享到朋友圈、分享到空间
            wx.updateTimelineShareData({
                title: dataForWeiXin.title,
                link: dataForWeiXin.link,
                imgUrl: dataForWeiXin.imgUrl,
                success:function(){

                }
            })
        })
        wx.error(function(res){
        })
    })    
}

export default {
    getJSSDK: getJSSDK
}


// WEBPACK FOOTER //
// ./src/assets/api/wx_sdk.js